import { Outlet } from 'react-router-dom';
import { LinearProgress, MenuBottomsheet } from 'oui';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';

export const MtgConditions = () => {
  const {
    progress,
    mappedCodeList,

    navigate,
    navigateNextStep,

    selectSheet,
    openSelectSheet,

    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,

    saveInputInfoTemp,
    saveInputInfo
  } = useMtgConditions();

  return (
    <>
      <LinearProgress value={progress} />
      <Outlet
        context={{
          mappedCodeList,
          navigate,
          navigateNextStep,
          selectSheet,
          openSelectSheet,
          mortgageInfo,
          onChangeWrappingInput,
          onChangeInput,
          saveInputInfoTemp,
          saveInputInfo
        }}
      />
    </>
  );
};
